import { render, staticRenderFns } from "./swiperAbout.vue?vue&type=template&id=f822550a&"
import script from "./swiperAbout.vue?vue&type=script&lang=js&"
export * from "./swiperAbout.vue?vue&type=script&lang=js&"
import style0 from "./swiperAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f822550a')) {
      api.createRecord('f822550a', component.options)
    } else {
      api.reload('f822550a', component.options)
    }
    module.hot.accept("./swiperAbout.vue?vue&type=template&id=f822550a&", function () {
      api.rerender('f822550a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperAbout/swiperAbout.vue"
export default component.exports